import { render, staticRenderFns } from "./Itineraries.vue?vue&type=template&id=9ffa0a08&"
import script from "./Itineraries.vue?vue&type=script&lang=js&"
export * from "./Itineraries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports